const organizationEmailTranslations = {
  label: "Fall E-Mail-Adresse",
  email: {
    label: "E-Mail-Adresse",
  },
};

export default organizationEmailTranslations;
